export default function Footer() {
    return (
        <footer className="foot">
            <small>© 2022 Shaunak development. All rights reserved.</small>
        </footer>
    )
}